import React, { useState, useEffect } from "react";
import "./Coins.css";
import { Link } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import { GiTwoCoins } from "react-icons/gi";
import Alert from "../../Components/Alert/Alert";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import { useBaseUrl } from "../../ApiContext";

export default function Coins() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const [invitationCode, setInvitationCode] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [coinsCount, setCoinsCount] = useState(0);
  const [alertText, setAlertText] = useState("");

  const copyToClipboard = () => {
    navigator.clipboard.writeText(invitationCode);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("کپی شد");
  };

  useEffect(() => {
    const fetchInvitationCode = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/invitation`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setInvitationCode(response.data.invite_code);
        setCoinsCount(response.data.point);
      } catch (error) {
        console.log("Error during getting invitation code", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("خطا در برقراری ارتباط");
      }
    };
    if (userToken) {
      fetchInvitationCode();
    }
  }, [baseUrl, userToken]);
  
  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="coinsHeader horizontalBorder centeredFlex">
            <img src="/images/bigCoin.svg" alt="coin icon" />
          </div>
          <div className="coinCharging horizontalBorder centeredFlex">
            <div className="coinsStock">
              <GiTwoCoins className="coinsIcon" />
              <span className="coinsStockText">موجودی سکه شما</span>
              <span className="coinsCount">{coinsCount}</span>
            </div>
            <Link to="/chargeCoin" className="coinChargingBtn link">
              شارژ سکه
            </Link>
          </div>
          <div className="introducerCode horizontalBorder">
            <h6>با ارسال کد معرف خود سکه هدیه بگیرید!</h6>
            <p>
              در صورتی که دوستانتان، با کد هدیه شما وارد REDROSE شوند، در قبال
              هر نفر 5 سکه دریافت خواهید کرد.
            </p>
            <div className="copyCode centeredFlex">
              <div className="copyCodeField">{invitationCode}</div>
              <button onClick={copyToClipboard}>کپی</button>
            </div>
          </div>
          <div className="getCoinsMethods horizontalBorder">
            <h4>روش های دریافت سکه:</h4>
            <ul>
              <li>
                - افزایش امتیاز کلی (مجموع امتیاز شرکت در کلاس ها + شرکت در چالش
                ها).
              </li>
              <li>
                - امتیاز کلی در قسمت بدن من و در کادر زرد رنگ قابل مشاهده است.
              </li>
              <li>- شرکت در چالش ها.</li>
              <li>- ارسال کد معرف.</li>
            </ul>
          </div>
          <Alert showAlert={showAlert} alertText={alertText} bottom="5rem" />
        </div>
      </div>
    </div>
  );
}
